export const webview = {
  webviewContent: "Il s'agit d'une URL externe et elle sera ouverte dans une nouvelle fenêtre. Ouvrir ?",
  webviewButtonOpenTitle: 'Ouvrir',
  webviewButtonCopyTitle: "Copier l'URL",
  webviewButtonOpenAgainTitle: 'Ouvrir à nouveau',
  notifications: {
    urlCopied: 'URL copiée !'
  }
}
